import React, { useEffect, useState } from 'react'
import Menu from '../../components/Menu'
import Header from '../../components/Header'
import { withPaddingPage } from '../../config/Util'
import Strings from '../../config/Strings'
import AccountInfo from '../../components/AccountInfo'
import { useHistory } from 'react-router-dom'
import { AccountService } from '../../services/AccountService'
import Dialog from '../../components/Dialog'
import ReactRoutes from '../../config/ReactRoutes'
import { LogInRegisterService } from '../../services/LogInRegisterService'

function ChangeComapny(props) {

    withPaddingPage()

    const [allCompanies, setAllCompanies] = useState([])
    const [companySectors, setCompanySectors] = useState([])

    const [selectedCompany, setSelectedCompany] = useState("")
    const [selectedSector, setSelectedSector] = useState("")
    const [yourPassword, setYourPassword] = useState("")
    const [showDialog, setShowDialog] = useState(false)
    const [dialogData, setDialogData] = useState({})
    const [showErrorDialog, setShowErrorDialog] = useState(false)
    const [errorDialogData, setErrorDialogData] = useState({})

    const history = useHistory()

    useEffect(() => {
        LogInRegisterService.getAllCompanies()
            .then(response => setAllCompanies(response))
            .catch(error => console.log(error))
    }, [])

    function getCompanySectors(e) {
        let companyId = e.target.value
        setSelectedCompany(companyId)

        LogInRegisterService.getCompanySectors(companyId)
            .then(response => {
                setCompanySectors(response)
                setSelectedSector('')

                document.getElementById("sectorSelect").selectedIndex = 0
            })
            .catch(error => console.log(error))
    }

    function changeCompany(e) {
        if (validateInput()) {
            let targetClassList = e.target.classList;
            targetClassList.add("spinner")

            AccountService.changeCompany(yourPassword, selectedCompany, selectedSector)
                .then(response => {
                    if (response === "novaustanovauspesna") {
                        setDialogData({
                            title: Strings.COMPANY_CHANGED
                        })
                        setShowDialog(true)
                        props.triggerRefreshSessionData()
                    } else {
                        setErrorDialogData({
                            title: response
                        })
                        setShowErrorDialog(true)
                    }
                    targetClassList.remove("spinner")
                })
                .catch(error => {
                    console.log(error)
                    targetClassList.remove("spinner")
                })
        }
    }

    function validateInput() {
        let valid = true

        if (!selectedCompany || !selectedSector || !yourPassword) {
            valid = false
            setErrorDialogData({
                title: Strings.ERROR_MUST_FILL_ALL_FIELDS
            })
        }

        setShowErrorDialog(!valid)
        return valid
    }

	return (
        <div>
            <Header back={ () => history.goBack() } text={Strings.CHANGE_COMPANY} />
            <AccountInfo
                name={props.sessionData.name}
                lastName={props.sessionData.lastName}
                telephone={props.sessionData.telephone}
                email={props.sessionData.email}
                companyName={props.sessionData.companyName}   
            />

            <p className="text show-animation">{Strings.TEXT_CHANGE_COMPANY}</p>

            <select onChange={getCompanySectors} className="input mt2rem show-animation" defaultValue="">
                <option disabled value="">Izaberite ustanovu</option>
                {
                    allCompanies.map(company => {
                        return <option key={company[0]} value={company[0]}>{company[1]}</option>
                    })
                }
            </select>
            
            <select id="sectorSelect" onChange={ (e) => setSelectedSector(e.target.value) } className="input show-animation" defaultValue="">
                <option disabled value="">Izaberite odeljenje</option>
                {
                    companySectors.map(sector => {
                        return <option key={sector[0]} value={sector[0]}>{sector[1]}</option>
                    })
                }
            </select>

			<input onChange={ (e) => setYourPassword(e.target.value) } className="input show-animation" placeholder="Vaša lozinka" type="password" />

            <button onClick={changeCompany} className="btn btn-green mt2rem show-animation">{Strings.SAVE}</button>

            <Menu active="account" />

            {
				showDialog ? <Dialog primaryText={Strings.OK} primaryAction={ () => history.push(ReactRoutes.ACCOUNT) } data={dialogData} /> : null
			}

            {
				showErrorDialog ? <Dialog primaryText={Strings.OK} primaryAction={ () => setShowErrorDialog(false) } data={errorDialogData} /> : null
			}
        </div>
	)
}

export default ChangeComapny
